import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableDelegate, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { FinancialLineItemCashFlowType, IFinancialLineItemExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { getKeyFromValueOfNumericEnum } from '../../utils/EnumUtils';
import { getDebug, getTag } from '../../utils/debugUtil';
import { getLocalizationFromAsyncPipe } from '../../utils/localizationUtils';
import { I18NextService } from 'angular-i18next';
const filename =
    'projects/aumico-lib-settings-fe/src/lib/components/financial-line-item-list/financial-line-item-list.component.ts';

const debug = getDebug(filename);
const TAG = getTag(filename);

// tslint:disable: jsdoc-format
/**
 * How to use

    //  <settings-financial-line-item-list-component
    [data]="data"
    [languages]="languages"
    (editPressed)="editPressedEventHandler($event)"

    >
    </settings-financial-line-item-list-component>
 *
 */
// tslint:enable: jsdoc-format

@Component({
    selector: 'settings-financial-line-item-list-component',
    template: ` <aumico-table [options]="options" [data]="DATA" [delegate]="this"> </aumico-table> `
})
export class FinancialLineItemListComponent implements OnInit, ITableDelegate {
    public options: ITableOptions;
    private rawData: IFinancialLineItemExtendedDTO[];
    public DATA = [];

    @Input()
    public languages: string[] = ['de-ch', 'en-us'];

    @Output()
    public editPressed = new EventEmitter<string>();

    @Input()
    public set data(items: IFinancialLineItemExtendedDTO[]) {
        this.rawData = items;
        this.updateData(items);
    }
    public get data(): IFinancialLineItemExtendedDTO[] {
        return this.rawData;
    }

    constructor(private i18nextService: I18NextService) {
        this.prepareFields();
    }
    private updateData(data: IFinancialLineItemExtendedDTO[]) {
        this.DATA = data.map((item) => {
            // this is a simple adapter for the cashflow
            return {
                ...item,
                get cashflowName() {
                    return getKeyFromValueOfNumericEnum(FinancialLineItemCashFlowType, item.cashflow);
                },
                get item() {
                    return item;
                },
            };
        });
    }

    private async prepareFields() {
        this.options = {
            columns: [
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_id',
                    ),
                    type: 'text',
                    property: '_id',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_version',
                    ),
                    type: 'text',
                    property: 'version',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_owner',
                    ),
                    type: 'text',
                    property: 'owner',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_name',
                    ),
                    type: 'text',
                    property: 'name',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_description',
                    ),
                    type: 'translated-text',
                    property: 'description',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_cashflow',
                    ),
                    type: 'text',
                    property: 'cashflowName',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_position',
                    ),
                    type: 'text',
                    property: 'position',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_financialLineItem_type',
                    ),
                    type: 'text',
                    property: 'type',
                },
                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_button_edit'),
                    type: 'button',
                    property: '_id',
                    action: 'edit',
                },
            ],
        };
    }
    ngOnInit(): void {
        this.prepareFields();
    }

    onMenuItemClick(action: string, selectedRows: SelectionModel<any>) {
        debug('onMenuItemClick', action, selectedRows);
    }

    onRowButtonClicked(itemParam: string, action?: string): void {
        if (action === 'edit') {
            this.editPressed.emit(itemParam);
        }
    }
}
